module.exports = __webpack_public_path__ + "img/menu_service_banner.da46547a.png";